var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueQrcode',_vm._g(_vm._b({attrs:{"value":_vm.value,"tag":"img","options":_vm.options}},'VueQrcode',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }